import React, { Component, Fragment } from 'react'
import axios from 'axios'
import isEmpty from 'lodash/isEmpty'

import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from '../../../shared/vars'

// CSS
import '../../../css/display-table.css'

class TopUsers extends Component {
    constructor(props){
        super(props)
        this.state = {
            dataLoaded: false,
            data: null,
            error: '',
            date_status: false,
            start_date: null,
            end_date: null,
            exporting: false,
            exportedFile: ""
        }
    }

    componentDidMount(){
        this.loadData();
    }

    loadData(){
        const endpoint = "summary/user-login?start=" + this.state.start_date + "&end=" + this.state.end_date;

        const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ':Bearer ' + this.props.user.token }
        return axios.get(REACT_APP_API_URL + endpoint, { headers: AUTH_HEADER })
		.then((response) => {
            if(response.status !== 200){
                this.setState({ dataLoaded: true, error: response.data.message })
            }else{
                this.setState({ dataLoaded: true, data: { ...response.data } })
            }
		})
		.catch((err) => {
			this.setState({ dataLoaded: true, error: err.response.data.errors ? err.response.data.errors : err.response.data.message })
		})
    }

    toggleDateInputs = () => {
        const { date_status } = this.state;

        if(date_status){
            this.setState({ 
                date_status: !date_status,
                start_date: null,
                end_date: null,
                exportedFile: ""
            }, () => this.loadData())
        } else {
            this.setState({ date_status: !date_status })
        }
    }

    handleInputChange = (value, type) => {
        const { start_date, end_date } = this.state;
        this.setState({
            [type]: value
        }, 
        () => {
            if(type === 'start_date'){
                if(end_date !== null) this.loadData();
            } else if (type === 'end_date'){
                if(start_date !== null) this.loadData();
            }
        }
        )
    }

    exportData = () => {
        this.setState({
            exporting: true,
            exportedFile: ""
        }, () => {
            const item = {
                data: this.state.data,
                type: 'top_users',
                start_date: this.state.start_date,
                end_date: this.state.end_date
            }
    
            const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + this.props.user.token };
            return axios
            .post(REACT_APP_API_URL + "summary", item, { headers: AUTH_HEADER })
            .then((response) => {
                console.log(response);
                if(response.status !== 200){
                    this.setState({ error: response.data.message, exporting: false })
                }else{
                    this.setState({ exportedFile: response.data.file, exporting: false })
                }
            })
            .catch((err) => {
                this.setState({ error: err.response.data.errors ? err.response.data.errors : err.response.data.message, exporting: false })
            })
        })
    }

    render() {
        const { date_status } = this.state;

        return (
            <div className="chart_area chart_1_2">
                <div className="chart_area_header">
                    <h2>Top Users</h2>
                    <div>
                        <button className={"btn" + (date_status ? ' on' : '')}
                            onClick={() => this.toggleDateInputs()}
                        >{date_status ? 'Reset' : 'Filter By Date'}</button>
                        {date_status && 
                            <button className="btn export-btn" onClick={(e) => {
                                if(this.state.exportedFile !== ""){
                                    e.preventDefault();
                                    window.location.href = '' + this.state.exportedFile;
                                }
                                else{
                                    this.exportData()
                                }
                            }}>
                            {this.state.exporting ? 'Exporting...' : (this.state.exportedFile === "" ? 'Export' : 'Download')}
                            </button>
                        }
                    </div>
                </div>
                {date_status ?
                <div className="date-picker-row">
                    <input type="date" onChange={e => this.handleInputChange(e.target.value, 'start_date')}></input>
                    <input type="date" onChange={e => this.handleInputChange(e.target.value, 'end_date')}></input>
                </div> : <Fragment></Fragment>
                }
                {this.state.dataLoaded ? (
                    <table className="display_table light_table">
                        <thead>
                            <tr className="table-header">
                                <th></th>
                                <th>Email</th>
                                <th className="right_aligned">Login Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isEmpty(this.state.data) ? <tr><td colSpan="3" style={{fontStyle: 'italic'}}>No results found for the selected date range.</td></tr> : 
                            Object.keys(this.state.data).map((key, index) =>
                                <tr key={key}>
                                    <td className="record-number">{index + 1}</td>
                                    <td data-id="Sku">{this.state.data[key].email}</td>
                                    <td data-id="Inventory" className="right_aligned">{this.state.data[key].login_count}</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                ) : (
                    null
                )}
            </div>
        )
    }
}

export default TopUsers



// WEBPACK FOOTER //
// ./src/components/admin/dashboard/TopUsers.js